import React from "react";

const ProjectHistoryMain = () => {
  return <div className="mb-40"></div>;
};

export default ProjectHistoryMain;
